import { Routes, Route } from 'react-router-dom';
import AppShell from './components/AppShell.jsx';
import RequireOperator from './components/RequireOperator.jsx';
import Login from './pages/Login.jsx';
import Callback from './pages/Callback.jsx';
import Landing from './pages/Landing.jsx';
import Dashboard from './pages/Dashboard.jsx';
import Onboarding from './pages/Onboarding.jsx';
import Customers from './pages/Customers.jsx';
import CustomerDetail from './pages/CustomerDetail.jsx';
import { customerSectionRoutes } from './pages/CustomerSections.jsx';
import { DataReferenceRoute, LegacySettingsRedirect } from './pages/LegacyRedirect.jsx';
import ConsentComplete from './pages/ConsentComplete.jsx';
import WatchReview from './pages/watch/WatchReview.jsx';
import WatchPreferencesPage from './pages/watch/WatchPreferencesPage.jsx';
import ReviewPage from './pages/access-reviews/ReviewPage.jsx';
import Security from './pages/Security.jsx';
import NotFound from './pages/NotFound.jsx';

export default function App() {
  return (
    <Routes>
      {/* Public / pre-auth routes */}
      <Route path="/login" element={<Login />} />
      {/* Public architecture and security FAQ: no session, no sign-in step */}
      <Route path="/security" element={<Security />} />
      {/* ENTRAID-347 (plan C8): the page's name, as a short alias */}
      <Route path="/trust" element={<Security />} />
      <Route path="/callback" element={<Callback />} />
      {/* Microsoft admin-consent reply address (ENTRAID-248); no session needed */}
      <Route path="/consent-complete" element={<ConsentComplete />} />

      {/* onGuard Watch capability pages (spec 9.4): no session, no sidebar, no login */}
      <Route path="/watch/review" element={<WatchReview />} />
      <Route path="/watch/preferences" element={<WatchPreferencesPage />} />
      {/* Access reviews: the reviewer link (spec 2026-10-26, 13.2). No session, no sidebar; a page load records nothing */}
      <Route path="/access-reviews/review" element={<ReviewPage />} />

      {/* Onboarding keeps its full-screen wizard, outside the workbench */}
      <Route path="/onboarding" element={<Onboarding />} />

      {/* The workbench (portal workbench spec, 2026-09-29) */}
      <Route path="/" element={<AppShell />}>
        <Route index element={<Landing />} />
        <Route path="fleet" element={<RequireOperator><Dashboard /></RequireOperator>} />
        <Route path="customers" element={<RequireOperator><Customers /></RequireOperator>} />
        <Route path="customers/:customerId" element={<CustomerDetail />}>
          {customerSectionRoutes()}
        </Route>
        <Route path="data-reference" element={<DataReferenceRoute />} />
        {/* Old URL: Collection of the active customer (today's SettingsRedirect) */}
        <Route path="settings" element={<LegacySettingsRedirect />} />
      </Route>

      {/* Anything else: a not-found page with a way home, never a blank screen */}
      <Route path="*" element={<NotFound />} />
    </Routes>
  );
}
